export default {
  init() {
    const header = document.querySelector('.header');
    let prevScrollpos = window.pageYOffset;
    window.onscroll = function() {
      const currentScrollPos = window.pageYOffset;
      if (prevScrollpos > currentScrollPos) {
        header.classList.add('is-visible');
      } else if (
        document.body.scrollTop > 150 ||
        document.documentElement.scrollTop > 150
      ) {
        header.classList.remove('is-visible');
      } else {
        // header.classList.remove('is-visible');
      }

      if (
        document.body.scrollTop > 80 ||
        document.documentElement.scrollTop > 80
      ) {
        header.classList.add('is-green');
      } else {
        header.classList.remove('is-green');
      }
      prevScrollpos = currentScrollPos;
    };
  }
};
